import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Play({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M9.66917 16.0818C9.22473 16.3411 8.66659 16.0205 8.66659 15.506V8.494C8.66659 7.97948 9.22473 7.6589 9.66917 7.91815L15.6794 11.4241C16.1204 11.6814 16.1204 12.3186 15.6794 12.5758L9.66917 16.0818Z"
        fill={iconColor}
      />
      <Path
        d="M11.9999 1.33331C6.10888 1.33331 1.33325 6.10894 1.33325 12C1.33325 17.891 6.10888 22.6666 11.9999 22.6666C17.891 22.6666 22.6666 17.891 22.6666 12C22.6666 6.10894 17.891 1.33331 11.9999 1.33331ZM2.66659 12C2.66659 6.84532 6.84526 2.66665 11.9999 2.66665C17.1546 2.66665 21.3333 6.84532 21.3333 12C21.3333 17.1546 17.1546 21.3333 11.9999 21.3333C6.84526 21.3333 2.66659 17.1546 2.66659 12Z"
        fill={iconColor}
      />
    </Svg>
  );
}
